import { Link } from 'react-router-dom'
import SEO from '../../seo/SEO'
import './NotFound.css'

const NotFound = () => {
  return (
    <>
      <SEO 
        title="Página no encontrada"
        description="La página que buscas no existe. Volvé al inicio o explorá nuestros servicios contables profesionales."
        canonical="https://vanesamondejar.com/404"
      />
      
      <main className="notfound">
        <div className="container">
          <div className="notfound__content">
            <div className="notfound__error">
              <h1 className="notfound__error-code">404</h1>
              <h2 className="notfound__error-title">Página no encontrada</h2>
              <p className="notfound__error-description">
                Lo sentimos, la página que buscas no existe o ha sido movida.
              </p>
            </div>
            
            <div className="notfound__suggestions">
              <h3 className="notfound__suggestions-title">¿Qué podés hacer?</h3>
              <ul className="notfound__suggestions-list">
                <li>Verificá que la URL esté escrita correctamente</li>
                <li>Volvé a la página de inicio</li>
                <li>Explorá nuestros servicios</li>
                <li>Contactanos si necesitás ayuda</li>
              </ul>
            </div>
            
            <div className="notfound__actions">
              <Link to="/" className="notfound__button notfound__button--primary">
                🏠 Volver al Inicio
              </Link>
              <Link to="/servicios" className="notfound__button notfound__button--secondary">
                📋 Ver Servicios
              </Link>
              <Link to="/contacto" className="notfound__button notfound__button--tertiary">
                📞 Contactar
              </Link>
            </div>
            
            <div className="notfound__help">
              <h3 className="notfound__help-title">¿Necesitás ayuda?</h3>
              <p className="notfound__help-description">
                Si seguís teniendo problemas, contactanos por WhatsApp y te ayudaremos inmediatamente.
              </p>
              <a 
                href="https://wa.me/5491166201346" 
                target="_blank" 
                rel="noopener noreferrer"
                className="notfound__whatsapp"
              >
                📱 Contactar por WhatsApp
              </a>
            </div>
          </div>
        </div>
      </main>
    </>
  )
}

export default NotFound
